// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QCRrW","rootMobile":"styles_rootMobile__2QFOs"};